import { SvgPlus } from "../../../components/icons"
import { useState } from "react"

const BusinessBootcampFAQs: React.FC = () => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null)

  const toggleFAQ = (index: number) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index))
  }

  const faqs = [
    {
      question: "Do I need to already have a coaching business?",
      answer:
        "No. Whether you’re just starting out or looking to grow, this program will provide strategies, approaches, and tactics you can use at any stage of your business",
    },
    {
      question: "Will I need to spend time outside the sessions?",
      answer:
        "The 90-minute live sessions are the heart of the training. Each day you’ll have a short pre-work exercise to prepare and a clear action step to apply afterward. Although this can vary person to person, you can anticipate about 30 minutes of total participation before and after each training session. You can always spend more time refining your work if you’d like, but you’ll stay on track simply by showing up live and completing the daily action.",
    },
    {
      question:
        "Will I be able to connect with other coaches or ask questions?",
      answer:
        "Yes! Each session includes time for discussion and interactive exercises. You’ll also be part of an exclusive community of coaches going through the program together, where you can share insights, ask questions, and build meaningful connections throughout the week.",
    },
    {
      question: "What if I can’t attend all 5 sessions live?",
      answer:
        "We strongly encourage attending live, as the bootcamp is designed to be interactive and action-oriented. If something unavoidable comes up, recordings may be provided on a case-by-case basis..​",
    },
    {
      question: "Is this for any type of coach?",
      answer:
        "Yes, this training is intended for all coaches who want to build heart-centered, service-based, highly-profitable practices.​",
    },
    {
      question: "What if I’ve taken other business trainings",
      answer:
        "Many business trainings for coaches follow conventional, misaligned, or outdated tactics from people who don’t truly understand the profession. This bootcamp is different from most everything out there. It’s practical, action-oriented, and built upon Zoee’s Hierarchy of Needs for Coaches™ framework, delivering best-in-class guidance that isn’t available anywhere else",
    },
    {
      question: "What if I’m not satisfied?",
      answer: (
        <>
          This is not a “dip your toe in” kind of program. It’s designed for
          coaches who are ready to show up fully, play full out, and create real
          results. Transformation requires commitment, and that starts the
          moment you enroll.
          <br />
          <br />
          That said, we also understand that things change, which is why we
          offer a full refund before the program begins. After that, there are
          no refunds provided, unless there are extenuating circumstances, which
          will be reviewed case by case.
          <br />
          <br />
          We don’t position this as a risk-free, money-back guarantee, because
          that’s not how transformation works. Fear and risk are part of growth.
          If you’re in, we want you all in, not halfway. That’s how you’ll get
          the most out of this experience.
        </>
      ),
    },
    {
      question: "What platform is this hosted on? Do I need special software?",
      answer:
        "The training is hosted live via Zoom, and all materials will be provided through Zoee’s platform. You don’t need any special software beyond Zoom and an internet connection. Everything else will be provided and easy to access.​",
    },
    {
      question: "What happens after the bootcamp?",
      answer:
        "You’ll have a personalized roadmap that you can use to build your business, along with the resources to implement it. You’ll also receive an exclusive opportunity only available for bootcamp participants.​",
    },
  ]

  return (
    <div className="flex flex-col md:flex-row items-start justify-between w-full py-[56px] md:py-[96px] gap-10 mx-auto md:px-[144px] px-4 sm:px-8 max-w-screen-xl mx-auto">
      {/* Left Section - Title and Contact */}
      <div className="md:w-[400px] flex flex-col gap-4">
        <h2 className="text-black text-[48px] font-bold leading-tight">
          Frequently Asked Questions
        </h2>
        <p className="text-black text-[18px] font-normal">
          Not seeing your question here? Contact us at{" "}
          <a
            href="mailto:support@zoee.com"
            className="underline font-bold break-words text-vividRed"
          >
            support@zoee.com
          </a>
        </p>
      </div>

      {/* Right Section - FAQs */}
      <div className="flex flex-col w-full lg:w-2/3 gap-6">
        {faqs.map((faq, index) => (
          <div key={index} className="flex flex-col">
            <div className="flex justify-between items-center">
              <p className="text-black text-[24px] font-bold">{faq.question}</p>
              <button
                onClick={() => toggleFAQ(index)}
                aria-label={`Toggle answer for: ${faq.question}`}
                className="w-6 h-6"
              >
                <SvgPlus
                  className={`transform ${
                    expandedIndex === index ? "rotate-45" : ""
                  }`}
                />
              </button>
            </div>
            {expandedIndex === index && (
              <p className="text-black text-[24px] font-normal mt-4">
                {faq.answer}
              </p>
            )}
            <hr className="border-t border-[#383838] mt-4" />
          </div>
        ))}
      </div>
    </div>
  )
}

export default BusinessBootcampFAQs
